import { render, staticRenderFns } from "./SidebarItemGroup.vue?vue&type=template&id=1070d2a4&scoped=true"
import script from "./SidebarItemGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarItemGroup.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SidebarItemGroup.vue?vue&type=style&index=0&id=1070d2a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1070d2a4",
  null
  
)

export default component.exports